import React, {} from 'react';
const styles = {"cards":"ResearchCards-module__cards__Ut8JK","card":"ResearchCards-module__card__LmdVs","title":"ResearchCards-module__title__TJjP0","line":"ResearchCards-module__line__FW3JP","citation":"ResearchCards-module__citation__7PBxA","note":"ResearchCards-module__note__FNmDn"};
/** "Why it works": white cards, each a research finding with its citation, then a short note. */
export function ResearchCards({ cards, note }) {
    return (React.createElement("div", null,
        React.createElement("ul", { className: styles.cards }, cards.map((card, index) => (React.createElement("li", { key: index, className: styles.card },
            React.createElement("h3", { className: styles.title }, card.title),
            React.createElement("p", { className: styles.line }, card.line),
            React.createElement("p", { className: styles.citation }, card.citation))))),
        React.createElement("p", { className: styles.note }, note)));
}
//# sourceMappingURL=ResearchCards.js.map